import { instatusConfig } from "@/config/instatus";
import { useQuery } from "@tanstack/react-query";
import { getInstatusOutageBannerState, type InstatusSummaryResponse } from "@rebuild/shared";
import { INSTATUS_KEYS } from "./queryKeys";

const MAX_STATUS_AGE_MS = 5 * 60 * 1000;

async function fetchInstatusSummary(): Promise<InstatusSummaryResponse> {
  const response = await fetch(instatusConfig.summaryUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch Instatus summary: ${response.status}`);
  }
  return response.json() as Promise<InstatusSummaryResponse>;
}

export function useInstatusStatusQuery() {
  const query = useQuery({
    queryKey: INSTATUS_KEYS.summary(),
    queryFn: fetchInstatusSummary,
    refetchInterval: instatusConfig.pollIntervalMs,
    refetchIntervalInBackground: false,
    refetchOnMount: "always",
    refetchOnReconnect: "always",
    refetchOnWindowFocus: "always",
    retry: 1,
    staleTime: 0,
  });

  const isFresh = Date.now() - query.dataUpdatedAt <= MAX_STATUS_AGE_MS;
  const data = query.data && isFresh ? getInstatusOutageBannerState(query.data) : undefined;

  return {
    ...query,
    data,
  };
}
